<div class="ai-price-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ (isEdit ? 'SETTINGS.AI_PRICE.EDIT' : 'SETTINGS.AI_PRICE.CREATE') | translate }}</span>
		<button mat-icon-button (click)="cancel()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		<form [formGroup]="form" (ngSubmit)="save()">
			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRICE.PROVIDER' | translate }}</mat-label>
					<mat-select formControlName="provider">
						@for (provider of providerOptions; track provider) {
						<mat-option [value]="provider">{{ 'SETTINGS.AI_PRESET.PROVIDERS.' + provider | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRICE.MODEL' | translate }}</mat-label>
					<input matInput formControlName="model" placeholder="gpt-4o-mini" />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRICE.PRICE_PER_MILLION_INPUT_TOKENS' | translate }}</mat-label>
					<input matInput type="number" step="0.000001" min="0" formControlName="pricePerMillionInputTokens" />
					<span matTextSuffix>USD</span>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRICE.PRICE_PER_MILLION_OUTPUT_TOKENS' | translate }}</mat-label>
					<input matInput type="number" step="0.000001" min="0" formControlName="pricePerMillionOutputTokens" />
					<span matTextSuffix>USD</span>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRICE.PRICE_PER_MILLION_CACHED_INPUT_TOKENS' | translate }}</mat-label>
					<input matInput type="number" step="0.000001" min="0" formControlName="pricePerMillionCachedInputTokens" />
					<span matTextSuffix>USD</span>
					<mat-hint>{{ 'SETTINGS.AI_PRICE.CACHED_PRICE_HINT' | translate }}</mat-hint>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.AI_PRICE.EFFECTIVE_FROM' | translate }}</mat-label>
					<input matInput [matDatepicker]="effectiveFromPicker" formControlName="effectiveFrom" />
					<mat-datepicker-toggle matIconSuffix [for]="effectiveFromPicker"></mat-datepicker-toggle>
					<mat-datepicker #effectiveFromPicker></mat-datepicker>
				</mat-form-field>
			</div>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="pe-4">
		<mat-divider class="w-100 my-2"></mat-divider>
		<div class="gap-2 d-flex justify-content-end pt-0">
			<button mat-flat-button type="button" color="primary" (click)="save()" [disabled]="form.invalid || saving">
				{{ 'BUTTON.SAVE' | translate }}
			</button>
			<button mat-flat-button type="button" color="primary" (click)="cancel()">
				{{ 'BUTTON.CANCEL' | translate }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
